import React, { PropsWithChildren } from "react";

interface VisibleProps extends PropsWithChildren {
  isVisible?: boolean;
}

const Visible: React.FC<VisibleProps> = (props) => {
  const { isVisible = true, children } = props;
  if (!isVisible) {
    return null;
  }
  return children;
};

export default Visible;
